import styled from 'styled-components'
import { colors, fontScope, radius } from '../tokens'

export const Label = styled.label<{ $disabled: boolean }>`
  ${fontScope}
  display: inline-flex;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`

export const Input = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
`

export const Box = styled.span<{ $checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  padding: 1.6px;
  border-radius: ${radius.checkbox};
  border: 1.6px solid ${({ $checked }) => ($checked ? colors.primaryStrong : colors.checkboxBorder)};
  background: ${({ $checked }) => ($checked ? colors.primaryStrong : colors.white)};

  ${Input}:focus-visible + & {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`

export const Text = styled.span<{ $dense: boolean }>`
  font-size: 14px;
  font-weight: 500;
  line-height: ${({ $dense }) => ($dense ? 'normal' : '21px')};
  color: ${colors.ink700};
  white-space: nowrap;
`
